/*
 *  -----------------------------------------------------------------------
 *    <copyright file="report-templates.interface.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { components } from 'types/rest-schema';
import Constants from '@utils/constants';

export type ItemWithPrefixedRecordId = { _itemId?: string };

export type GetPowerBIReportTemplate = components['schemas']['PowerBiReportDto'];

export type GetPowerBIReportTemplatesRes = GetPowerBIReportTemplate[];

export type GetPowerBIReportFormatTypesRes = components['schemas']['ReportFormatTypeDto'][];

export type GetPowerBIModuleTypesRes = components['schemas']['ModuleTypeDto'][];

export type OpraReportTemplate = components['schemas']['BFFReportTemplateDto'] & ItemWithPrefixedRecordId;

export type GetOpraReportTemplatesRes = OpraReportTemplate[];

export type Signatory = components['schemas']['SignatoryDto'] & ItemWithPrefixedRecordId;

export type Attendee = components['schemas']['AttendeeDto'] & ItemWithPrefixedRecordId;

export type OrganizationReportTemplateVisibility = components['schemas']['OrganizationReportTemplateVisibilityDto'];

export type OrganizationReportTemplateVisibilityUpdate =
    components['schemas']['OrganizationReportTemplateVisibilityUpdateDto'];

export type SetTemplateVisibility = components['schemas']['SetTemplateVisibilityDto'];

export type RiskReview = components['schemas']['RiskReviewDto'] & ItemWithPrefixedRecordId;

export type GeneratedReport = components['schemas']['GeneratedReportDto'] & ItemWithPrefixedRecordId;

export type ReportSignatory = components['schemas']['ReportSignatoryDto'];

export type ReportDownload = components['schemas']['ReportDownloadDto'];

export enum GeneratedReportStatus {
    Queued = 1,
    Ready = 2,
    Failed = 3,
    Obsolete = 4,
}

export type ReportModules = Constants.Modules.CM | Constants.Modules.RAM;
